import { useQuery } from 'react-query';

import { DocChronologySummary } from '../../../../backend/src/case/chronology/doc-chronology/dto/get-doc-chronologies-response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMatterDocChronologies = ({ matterId }: { matterId: string | null }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<DocChronologySummary[]>(
    [QueryEntity.MatterDocChronologies, { matterId }],
    async () => {
      return fetch(`${APIBaseChronos}/api/matters/${matterId}/doc-chronologies`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    { refetchOnWindowFocus: false, enabled: !!matterId },
  );
};
